import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalsPermissions {

  FUTURE: String = 'FuturePermissions';
  BASE: String = 'BaseSystem';
  MANAGE_USERS: String = 'ManageUsers';
  MANAGE_PROJECTS: String = 'ManageProjects';
  MANAGE_TEMPLATES: String = 'ManageTemplates';
  MANAGE_CONTRACTS_NO_VALUES: String = 'ManageContractsNoValues';
  MANAGE_CONTRACTS_VALUES: String = 'ManageContractsValues';
  COMPLETE_DAY: String = 'CompleteDay';
  BILLING: String = 'Billing';
  MANAGE_READERS: String = 'ManageReaders';
  SAFE_PROX_REPORT: String = 'CanViewContactTracingInfo';
}
